import { jsx as _jsx } from "react/jsx-runtime";
import { Message } from 'semantic-ui-react';
import { helpId } from '@rjsf/utils';
/** The `FieldHelpTemplate` component renders any help desired for a field
 *
 * @param props - The `FieldHelpProps` to be rendered
 */
export default function FieldHelpTemplate(props) {
    const { idSchema, help } = props;
    if (help) {
        const id = helpId(idSchema);
        return _jsx(Message, { size: 'mini', info: true, id: id, content: help });
    }
    return null;
}
//# sourceMappingURL=FieldHelpTemplate.js.map